/* app/js/src/components/external-mam/external-mam-gateway-playground/external-mam-customize-table/external-mam-customize-table.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.customize-table .customize-table-list::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.customize-table .customize-table-list::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.customize-table .customize-table-list::-webkit-scrollbar-corner {
  background: transparent;
}
.customize-table .customize-table-list::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.customize-table .customize-table-list::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.customize-table .customize-table-list::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.customize-table .customize-table-list::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.customize-table .customize-table-list::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  position: absolute;
  z-index: 5;
  top: 45px;
}
.customize-table {
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
}
.customize-table .customize-table-header {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.customize-table .customize-table-header .text {
  display: flex;
  padding: 15px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
}
.customize-table .customize-table-header .text span {
  flex: 1 0 0;
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
}
.customize-table .customize-table-header .close {
  display: flex;
  padding: 15px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
.customize-table .customize-table-selection-actions {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 10px 25px 10px 15px;
  flex: 1 0 0;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
}
.customize-table .customize-table-selection-actions .buttons {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.customize-table .customize-table-selection-actions .buttons span {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  text-transform: uppercase;
}
.customize-table .customize-table-selection-actions .buttons span.all {
  color: rgb(45, 187, 252);
}
.customize-table .customize-table-list {
  width: 100%;
  height: 28vh;
  -webkit-user-select: none;
  user-select: none;
  overflow-x: hidden;
  overflow-y: visible;
}
.customize-table .customize-table-list .drop-container {
  margin: 5px 15px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  gap: 10px;
}
.customize-table .customize-table-list .drop-container .col-box {
  display: flex !important;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.customize-table .customize-table-list .drop-container .col-box:active {
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.customize-table .customize-table-list .drop-container .col-box span {
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  flex: 1 0 0;
  text-transform: uppercase;
}
.customize-table .customize-table-list .drop-container .col-box .move {
  cursor: move;
}
.customize-table .customize-table-list .drop-container .drag-placeholder {
  background: rgb(235, 240, 244);
  border: dotted 3px rgba(0, 0, 0, 0.08);
  min-height: 45px;
  width: 100%;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.customize-table .customize-table-list .drop-container .drag-preview {
  background-color: red;
}
.customize-table .customize-table-result-actions {
  display: flex;
  padding: 15px 25px 15px 15px;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.customize-table .customize-table-result-actions .buttons {
  display: flex;
  align-items: flex-start;
}
.customize-table .customize-table-result-actions .buttons div {
  cursor: pointer;
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
.customize-table .customize-table-result-actions .buttons div.apply {
  background: rgb(45, 187, 252);
  color: #ffffff;
}
/*# sourceMappingURL=external-mam-customize-table.component.css.map */
